import { Typography, Box } from '@mui/material';
import { BenefitSet } from '@pxtra-client-lib-legacy/gen';
import { FC, useEffect, useRef, useState } from 'react';
import { TooltipComponent } from '../../../atomic/feedback';

export const LastChangedCell: FC<{ row: BenefitSet }> = ({ row }) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const formatDate = (dateString: string) => {
    return new Date(dateString)
      .toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      })
      .replace(',', ' •');
  };

  useEffect(() => {
    if (textRef.current) {
      setShowTooltip(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [row.name]);

  const lastChangedBy = (
    <Typography ref={textRef} className="text-sm truncate w-full">
      {row.last_changed_by ?? ''}
    </Typography>
  );

  return (
    <Box className="flex flex-col items-start max-w-[250px] min-w-[200px]">
      {showTooltip ? (
        <TooltipComponent arrow title={row.last_changed_by}>
          {lastChangedBy}
        </TooltipComponent>
      ) : (
        lastChangedBy
      )}
      <Typography className="text-xs text-grey-600">
        {row.last_changed_by && row.last_changed_at ? formatDate(row.last_changed_at) : '-'}
      </Typography>
    </Box>
  );
};
